import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashKeyBy from 'lodash/fp/keyBy';

import getTourListingsGoogleMapsDirectionsUrl from 'common/util/getTourListingsGoogleMapsDirectionsUrl';

import SrLink from 'client/components/SrLink/SrLink';

class SrAdminTourCardRoute extends Component {
  static propTypes = {
    steps: PropTypes.array.isRequired,
    route: PropTypes.array.isRequired,
    showings: PropTypes.array.isRequired,
    unqualifiedShowings: PropTypes.array.isRequired,
    totalTimeTourText: PropTypes.string.isRequired,
    timeByShowingText: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  render() {
    const {
      steps,
      route,
      showings,
      unqualifiedShowings,
      totalTimeTourText,
      timeByShowingText,
      onClose,
    } = this.props;
    const showingsByListingId = lodashKeyBy('listingId', showings);
    const googleMapsDirectionsUrl = getTourListingsGoogleMapsDirectionsUrl({
      listings: route.map((listingId) => showingsByListingId[listingId].listing),
      showings: route.map((listingId) => showingsByListingId[listingId]),
    });

    return (
      <div className="SrAdminTourCardRoute">
        <div className="header">
          <div className="title">{totalTimeTourText} total tour time</div>
          <div className="closeIcon" onClick={onClose} />
        </div>

        <div className="section">
          <div>
            <div className="title inline">
              {route.length}/{showings.length} showings are close enough to tour
            </div>

            {googleMapsDirectionsUrl && (
              <SrLink className="linkOut gmaps" target="_blank" to={googleMapsDirectionsUrl}>
                Route
              </SrLink>
            )}
          </div>
          {steps.map((step, stepIndex) => {
            return (
              <div key={step.startListingId} className="steps">
                <span>
                  {stepIndex + 1}. {step.startListingAddressStreetDisplay} ({timeByShowingText})
                </span>
                <div className="instruction">
                  <span>- {step.durationText}</span>
                </div>
                {steps.length === stepIndex + 1 && (
                  <span>
                    {steps.length + 1}. {step.endListingAddressStreetDisplay} ({timeByShowingText})
                  </span>
                )}
              </div>
            );
          })}
          {route.length === 1 && steps.length === 0 && (
            <div className="steps">
              <span>
                1. {showingsByListingId[route[0]].listing.addressStreetDisplay} ({timeByShowingText}
                )
              </span>
            </div>
          )}
        </div>

        {unqualifiedShowings.length > 0 && (
          <div className="section">
            <div className="title">
              {unqualifiedShowings.length}/{showings.length} showings don't fit
            </div>
            {unqualifiedShowings.map((unqualifiedShowing, index) => {
              const { listing } = showingsByListingId[unqualifiedShowing.listingId];

              return (
                <div key={unqualifiedShowing.listingId} className="steps">
                  <span>
                    {index + 1}. {listing.addressStreetDisplay} ({timeByShowingText})
                  </span>
                  <div className="instruction">
                    <span>- {unqualifiedShowing.reason}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

SrAdminTourCardRoute.displayName = 'SrAdminTourCardRoute';

export default SrAdminTourCardRoute;
